// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23GQ6","newExpiryDate":"styles_newExpiryDate__15MwP","footer":"styles_footer__MyEj0"};